export default [
    {
        path: '/user-token-list',
        name: 'user_token_list',
        component: () => import('@src/user-token/user-token-list'),
        meta: {
            title: 'User Token',
            role: 'ROLE_LIST_USER_TOKEN',
        },
    },
];
